import {Editor} from '@tinymce/tinymce-react';
import React from 'react';
import {tinyMceConfig} from '../helpers';

type Props = {
  value: string;
  onChange: ((value: string) => void);
}

const TinyMceInit = tinyMceConfig.init;

export class StaticHtmlEditor extends React.Component<Props> {
  handleEditorChange = (content: string) => {
    this.props.onChange(content);
  };

  render() {
    return (
      <div className="row">
        <div className="col">
          <Editor init={TinyMceInit}
                  value={this.props.value}
                  onEditorChange={this.handleEditorChange}/>
        </div>
      </div>);
  }
}
